"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Offset = void 0;
const Offset = () => ({
    offsetXs: 24,
    offsetMs: 32,
    offsetSm: 40,
    offsetMd: 48,
    offsetLg: 122,
    offsetMl: 64,
    offsetXl: 84,
});
exports.Offset = Offset;
